import { isDocumentNode } from 'anodum';
import text from '../../hdrm/injections/bindings/text';
import canBeSimpleEdited from '../../constraints/verifiers/can-be-simple-edited';
import isEmptyEditableElement from '../verifiers/is-empty-editable-element';
import { DEFAULT_BLOCK_TAG } from '../constants/editable-elements';
import getBlockFirstChildElement from './get-block-first-child-element';
import { NBSP_STRING } from '../constants/common';

const addSpaceToLastEmptyElementNode = (e) => {
  const { srcElement } = e;
  if (isDocumentNode(srcElement)) return;

  const contenteditableElement = text.getRootTextElement(srcElement);

  if (!contenteditableElement || !isEmptyEditableElement(contenteditableElement)) {
    return;
  }

  const isSimpleEdited = canBeSimpleEdited(contenteditableElement);

  if (isSimpleEdited) {
    contenteditableElement.innerHTML = NBSP_STRING;
    return;
  }

  const blockFirstElementChild = getBlockFirstChildElement(contenteditableElement);

  if (!blockFirstElementChild) {
    const { ownerDocument: liveDocument } = contenteditableElement;
    const paragraph = liveDocument.createElement(DEFAULT_BLOCK_TAG);
    contenteditableElement.appendChild(paragraph);
    contenteditableElement.firstElementChild.innerHTML = NBSP_STRING;
    return;
  }

  blockFirstElementChild.innerText = NBSP_STRING;
  contenteditableElement.innerHTML = contenteditableElement.firstElementChild.outerHTML;
};

export default addSpaceToLastEmptyElementNode;
